"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sports_1 = require("../sports");
var constants_1 = require("./constants");
function getMainSpecifiersBySportId(sportId) {
    switch (sportId) {
        case sports_1.Sports.ICE_HOCKEY:
        case sports_1.Sports.ESPORTS_ICE_HOCKEY: {
            return [constants_1.SpecifierName.periodnr, constants_1.SpecifierName.overtimenr];
        }
        case sports_1.Sports.FOOTBALL:
        case sports_1.Sports.ESPORTS_FIFA:
        case sports_1.Sports.HANDBALL:
        case sports_1.Sports.FUTSAL: {
            return [constants_1.SpecifierName.halfnr, constants_1.SpecifierName.overtimenr];
        }
        case sports_1.Sports.ESPORTS_BASEBALL:
        case sports_1.Sports.BASEBALL: {
            return [constants_1.SpecifierName.inningnr];
        }
        case sports_1.Sports.AMERICAN_FOOTBALL: {
            return [constants_1.SpecifierName.halfnr, constants_1.SpecifierName.quarternr];
        }
        case sports_1.Sports.BASKETBALL:
        case sports_1.Sports.ESPORTS_BASKETBALL: {
            return [
                constants_1.SpecifierName.quarternr,
                constants_1.SpecifierName.halfnr,
                constants_1.SpecifierName.overtimenr,
            ];
        }
        case sports_1.Sports.TENNIS:
        case sports_1.Sports.TABLE_TENNIS:
        case sports_1.Sports.ESPORTS_TENNIS:
        case sports_1.Sports.VOLLEYBALL:
        case sports_1.Sports.ESPORTS_VOLLEYBALL:
        case sports_1.Sports.BEACH_VOLLEYBALL:
        case sports_1.Sports.BADMINTON: {
            return [constants_1.SpecifierName.setnr];
        }
        case sports_1.Sports.ESPORTS_ARTIFACT:
        case sports_1.Sports.ESPORTS_BATTLEGROUNDS:
        case sports_1.Sports.ESPORTS_FORTNITE:
        case sports_1.Sports.ESPORTS_CALL_OF_DUTY_WARZONE: {
            return [constants_1.SpecifierName.gamenr];
        }
        case sports_1.Sports.ESPORTS_DOTA_2:
        case sports_1.Sports.ESPORTS_COUNTER_STRIKE:
        case sports_1.Sports.ESPORTS_RAINBOW_SIX:
        case sports_1.Sports.ESPORTS_CALL_OF_DUTY:
        case sports_1.Sports.ESPORTS_STARCRAFT:
        case sports_1.Sports.ESPORTS_STARCRAFT_1:
        case sports_1.Sports.ESPORTS_WORLD_OF_TANKS:
        case sports_1.Sports.ESPORTS_HEARTHSTONE:
        case sports_1.Sports.ESPORTS_HEROES_OF_THE_STORM:
        case sports_1.Sports.ESPORTS_LEAGUE_OF_LEGENDS:
        case sports_1.Sports.ESPORTS_OVERWATCH:
        case sports_1.Sports.ESPORTS_VAINGLORY:
        case sports_1.Sports.ESPORTS_WARCRAFT_3:
        case sports_1.Sports.ESPORTS_ROCKET_LEAGUE:
        case sports_1.Sports.ESPORTS_SMITE:
        case sports_1.Sports.ESPORTS_SOCCER_MYTHICAL:
        case sports_1.Sports.ESPORTS_HALO:
        case sports_1.Sports.ESPORTS_CROSSFIRE:
        case sports_1.Sports.ESPORTS_STREET_FIGHTER_5:
        case sports_1.Sports.ESPORTS_KING_OF_GLORY:
        case sports_1.Sports.ESPORTS_VALORANT:
        default: {
            return [constants_1.SpecifierName.mapnr];
        }
    }
}
exports.default = getMainSpecifiersBySportId;
//# sourceMappingURL=getMainSpecifiersBySportId.js.map